import React, { memo, useEffect, useState } from "react";
import useLocalStorage from "src/hooks/useLocalStorage";
import { Layout } from "antd";
import { Menubar } from "primereact/menubar";
import getRoutes from "src/app/routes";
import jwt_decode from "jwt-decode";
import { InputText } from "primereact/inputtext";
import { SplitButton } from "primereact/splitbutton";
import { Card } from "primereact/card";
import { useLocation } from 'react-router-dom';

function PanelLayout({ component: Component, route }) {
  const [collapse, setCollapse] = useLocalStorage("plano-menu-collapse", false);
  const { Header, Sider, Content } = Layout;
  const location = useLocation();
  const [token, setToken] = useState(
    jwt_decode(localStorage.getItem("plano-jwt"))
  );
  const [items, setItems] = useState([]);
  const itemsButtom = [
    {
      label: token.organization,
      icon: "pi pi-apple",
    },
  ];
  useEffect(() => {
    ///dashboard/pm/hfn/kpieditor_frameless
    //console.log("location", location);
    let routes = getRoutes(token.organization);
    if (location.pathname !== "/dashboard/pm/hfn/kpieditor_frameless") {
      setItems(routes);
    }


  }, []);
  const start = <h1 style={{ zIndex: 100, fontSize: "25px" }}>Plano </h1>;
  const end = () => {
    return (
      <SplitButton
        severity="secondary"
        label={
          token["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]
        }
        icon="pi pi-user"
        text
        model={itemsButtom}
      />
    );
  };

  return (
    <Layout className="h-full">
      <Layout className="h-full">

        {location.pathname !== "/dashboard/pm/hfn/kpieditor_frameless" && <Menubar
          start={start}
          end={end}
          model={items}
          style={{ zIndex: 100, fontSize: "14px" }}
        />}

        {/* <div className={`content-wrapper flex-grow transition-all duration-500 h-full`} style={{ backgroundColor: "#f6f6f6" }}       >
            <div className="block h-full content">
              <Component route={route} />
            </div>
          </div> */}
        <Content>
          <div className="h-full p-5 border bg-[#f6f6f6] border-gray-200 rounded-md">
            <div className="block h-full content">
              <Component route={route} />
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default memo(PanelLayout);
